
export const services = [
    {
        title: "Technology Enthusiast",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Software Engineer",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Test Automation Engineer",
        icon: 'https://csgeeek.github.io/web.png',
    },
];

export const name = 'Pranav';

export const experiences = [

    {
        'company': 'InfoTact SOlutions',
        'role': 'Associate Developer',
        'duration': 'January 2025    -  April 2025',
        'logo': 'https://infotact.in/white.png',
        'points': [
            'Led development of an advanced analytics app, that was approved for production.',
            ' Integrated the app with AI so that it would give more accurate and advanced solutions📱.',
            ' Implemented graphical usage and summarizer that helped the total work time to reduce by 30%.'
        ],
        'url': 'https://infotact.in/',
    },
    {
        'comapny' : 'Xebia Pvt. Ltd.',
        'role' : 'Web Developer Intern',
        'duration' : 'June 2024 - August 2024',
            'logo' : 'https://cdn.prod.website-files.com/6371f3e94a645947f33e2581/65424f18729df90a95ced8ba_Xebia.avif',
        'points' : [
            'Contributed to a production-ready web application for a unified student ecosystem.',
            'Cleared the exam for Azure devops certification during the internship period.',
            'Developed and maintained application dashboards, including frontend and API integrations.'

        ],
        'url' : 'https://xebia.com/'
    }
        // {
    //     
    //     'role': 'Freelancer',
    //     'duration': '',
    //     'logo': 'https://images.crunchbase.com/image/upload/c_pad,f_auto,q_auto:eco,dpr_1/e5gz1yggdy8sc1umna3e',
    //     'points': [
    //         'Worked as a freelancer for many  clients on different types of niche.',
    //         'I did content writing, data handling and as well as software development in some cases.',
    //         'All the clients I worked with gave me a good rating and also praised my for.',
    //         'Implemented data security for the company’s product to provide role-based access control over the system of software that was made to be a prod⚙️.'
    //     ],
    //     'url': 'https://inncircles.com/#home',
    // },
]



export const EMAIL_JS_SERVICE_ID = 'service_90wb9t5';
export const EMAIL_JS_TEMPLATE_ID = 'template_8l87rew';
export const EMAIL_JS_PUBLIC_KEY = 'pHPjc9RGGkF66r86N';

//npm run build then firebase deploy --only hosting